export default __webpack_public_path__ + "static/media/right-side-arrow.2c8472cf.svg";